import { AfterViewInit, Directive, input, Input } from "@angular/core";
import { ToggleSideNav } from "./toggle-side-nav";

@Directive({
  selector: "[toggleSideNav]",
})
export class ToggleSideNavDirective extends ToggleSideNav implements AfterViewInit {
  override sideNav = input.required<HTMLDivElement>({ alias: "toggleSideNav" });

  ngAfterViewInit(): void {
    this.calcActionBtnPosition(this.status());
  }
}
